(function () {
  'use strict';

  function initBunnyPlayerBackground() {
      document.querySelectorAll('[data-bunny-background-init]').forEach(function(player) {
        var src = player.getAttribute('data-player-src');
        if (!src) return;
        
    
        var video = player.querySelector('video');
        if (!video) return;
    
        try { video.pause(); } catch(_) {}
        try { video.removeAttribute('src'); video.load(); } catch(_) {}
    
        // Attribute helpers
        function setStatus(s) {
          if (player.getAttribute('data-player-status') !== s) {
            player.setAttribute('data-player-status', s);
          }
        }
        function setActivated(v) { player.setAttribute('data-player-activated', v ? 'true' : 'false'); }
        if (!player.hasAttribute('data-player-activated')) setActivated(false);
    
        // Flags
        var lazyMode   = player.getAttribute('data-player-lazy'); // "true" | "false" (no meta)
        var isLazyTrue = lazyMode === 'true';
        var autoplay   = player.getAttribute('data-player-autoplay') === 'true';
        var initialMuted = player.getAttribute('data-player-muted') === 'true';
    
        // Used to suppress 'ready' flicker when user just pressed play in lazy modes
        var pendingPlay = false;
    
        // Autoplay forces muted; IO will drive play/pause.
        // Do NOT set video.loop — we handle looping manually via the 'ended' event
        // to avoid hls.js restarting ABR from the lowest quality rendition on each loop.
        if (autoplay) { video.muted = true; }
        else { video.muted = initialMuted; }
    
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.playsInline = true;
        if (typeof video.disableRemotePlayback !== 'undefined') video.disableRemotePlayback = true;
        if (autoplay) video.autoplay = false;
    
        var isSafariNative = !!video.canPlayType('application/vnd.apple.mpegurl');
        // Prefer hls.js over native HLS whenever available — gives us control over
        // quality level selection. isSafariNative is kept as a fallback only.
        var canUseHlsJs    = !!(window.Hls && Hls.isSupported());
    
        // Attach media only once (for actual playback)
        var isAttached = false;
        var lastPauseBy = ''; // 'io' | 'manual' | ''
        function attachMediaOnce() {
          if (isAttached) return;
          isAttached = true;

          if (player._hls) { try { player._hls.destroy(); } catch(_) {} player._hls = null; }

          if (canUseHlsJs) {
            var hls = new Hls({
              maxBufferLength: 10,
              // Start with a 5 Mbps bandwidth estimate so hls.js picks a high-quality
              // rendition immediately rather than climbing up from the lowest level.
              abrEwmaDefaultEstimate: 5000000
            });
            hls.attachMedia(video);
            hls.on(Hls.Events.MEDIA_ATTACHED, function() { hls.loadSource(src); });
            hls.on(Hls.Events.MANIFEST_PARSED, function(_event, data) {
              // Force highest quality level immediately — skips the low-quality
              // startup ramp that makes background videos look blurry.
              if (data.levels.length > 1) {
                hls.currentLevel = data.levels.length - 1;
              }
              readyIfIdle(player, pendingPlay);
            });
            player._hls = hls;
          } else if (isSafariNative) {
            // Safari without hls.js support — use native HLS
            video.preload = isLazyTrue ? 'none' : 'auto';
            video.src = src;
            video.addEventListener('loadedmetadata', function() {
              readyIfIdle(player, pendingPlay);
            }, { once: true });
          } else {
            video.src = src;
          }
        }
    
        // Initialize based on lazy mode
        if (isLazyTrue) {
          video.preload = 'none';
        } else {
          attachMediaOnce();
        }
    
        // Toggle play/pause
        function togglePlay() {
          if (video.paused || video.ended) {
            if (isLazyTrue && !isAttached) attachMediaOnce();
            pendingPlay = true;
            lastPauseBy = '';
            setStatus('loading');
            safePlay(video);
          } else {
            lastPauseBy = 'manual';
            video.pause();
          }
        }
    
        // Toggle mute
        function toggleMute() {
          video.muted = !video.muted;
          player.setAttribute('data-player-muted', video.muted ? 'true' : 'false');
        }
    
        // Controls (delegated)
        player.addEventListener('click', function(e) {
          var btn = e.target.closest('[data-player-control]');
          if (!btn || !player.contains(btn)) return;
          var type = btn.getAttribute('data-player-control');
          if (type === 'play' || type === 'pause' || type === 'playpause') togglePlay();
          else if (type === 'mute') toggleMute();
        });
    
        // Media event wiring
        video.addEventListener('play', function() { setActivated(true); setStatus('playing'); });
        video.addEventListener('playing', function() { pendingPlay = false; setStatus('playing'); });
        video.addEventListener('pause', function() { pendingPlay = false; setStatus('paused'); });
        video.addEventListener('waiting', function() { setStatus('loading'); });
        video.addEventListener('canplay', function() { readyIfIdle(player, pendingPlay); });
        video.addEventListener('ended', function() {
          if (autoplay) {
            // Seek back to the start and resume — reuses already-buffered high-quality
            // segments so ABR doesn't restart from the lowest rendition on each loop.
            if (player._hls && player._hls.levels.length > 1) {
              player._hls.currentLevel = player._hls.levels.length - 1;
            }
            video.currentTime = 0;
            safePlay(video);
          } else {
            pendingPlay = false;
            setStatus('paused');
            setActivated(false);
          }
        });

        // Progress circle animation
        var progressCircle = player.querySelector('#bunny-bg__progress-circle circle');
        if (progressCircle) {
          var radius = parseFloat(progressCircle.getAttribute('r'));
          var circumference = 2 * Math.PI * radius;
          var isResetting = false;
          var lastProgress = 0;

          // Initialize stroke properties (no transition initially to avoid flash)
          // Note: rotation is handled by CSS on the parent .bunny-bg__progress-svg element.
          progressCircle.style.strokeDasharray = circumference;
          progressCircle.style.strokeDashoffset = circumference;

          // Enable transition after initial paint
          requestAnimationFrame(function() {
            progressCircle.style.transition = 'stroke-dashoffset 0.25s linear';
          });

          video.addEventListener('timeupdate', function() {
            if (isResetting || !video.duration) return;

            var progress = video.currentTime / video.duration;

            // Detect loop (progress jumped backwards significantly)
            if (lastProgress > 0.95 && progress < 0.1) {
              isResetting = true;
              // Animate the reset: stroke "wipes" away by animating dashoffset past 0
              if (window.gsap) {
                gsap.killTweensOf(progressCircle);
                progressCircle.style.transition = 'none';
                gsap.to(progressCircle, {
                  strokeDashoffset: -circumference,
                  duration: 0.4,
                  ease: 'power2.inOut',
                  onComplete: function() {
                    // Reset to start (no transition during snap back)
                    gsap.set(progressCircle, { strokeDashoffset: circumference });
                    // Delay re-enabling transition to next frame
                    requestAnimationFrame(function() {
                      requestAnimationFrame(function() {
                        progressCircle.style.transition = 'stroke-dashoffset 0.25s linear';
                        isResetting = false;
                        lastProgress = 0;
                      });
                    });
                  }
                });
              } else {
                // Fallback without GSAP
                progressCircle.style.transition = 'stroke-dashoffset 0.4s ease-in-out';
                progressCircle.style.strokeDashoffset = -circumference;
                setTimeout(function() {
                  progressCircle.style.transition = 'none';
                  progressCircle.style.strokeDashoffset = circumference;
                  // Re-enable smooth transition after two frames
                  requestAnimationFrame(function() {
                    requestAnimationFrame(function() {
                      progressCircle.style.transition = 'stroke-dashoffset 0.25s linear';
                    });
                  });
                  isResetting = false;
                  lastProgress = 0;
                }, 400);
              }
              return;
            }

            lastProgress = progress;
            var offset = circumference * (1 - progress);
            progressCircle.style.strokeDashoffset = offset;
          });
        }
    
        // In-view auto play/pause (only when autoplay is true)
        if (autoplay) {
          if (player._io) { try { player._io.disconnect(); } catch(_) {} }
          var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              var inView = entry.isIntersecting && entry.intersectionRatio > 0;
              if (inView) {
                if (isLazyTrue && !isAttached) attachMediaOnce();
                if ((lastPauseBy === 'io') || (video.paused && lastPauseBy !== 'manual')) {
                  setStatus('loading');
                  if (video.paused) togglePlay();
                  lastPauseBy = '';
                }
              } else {
                if (!video.paused && !video.ended) {
                  lastPauseBy = 'io';
                  video.pause();
                }
              }
            });
          }, { threshold: 0.1 });
          io.observe(player);
          player._io = io;
        }
      });
    
      // Helper: Ready status guard
      function readyIfIdle(player, pendingPlay) {
        if (!pendingPlay &&
            player.getAttribute('data-player-activated') !== 'true' &&
            player.getAttribute('data-player-status') === 'idle') {
          player.setAttribute('data-player-status', 'ready');
        }
      }
    
      // Helper: safe programmatic play
      function safePlay(video) {
        var p = video.play();
        if (p && typeof p.then === 'function') p.catch(function(){});
      }
    }
    
    // Initialize Bunny HTML HLS Player (Background)
    document.addEventListener('DOMContentLoaded', function() {
      initBunnyPlayerBackground();
    });

})();
